/**
 * Pinia Store Plugin Configuration
 *
 * This file configures the Pinia store with proper TypeScript support,
 * persistence, and development tools.
 */
import { createPinia } from 'pinia';
import type { App } from 'vue';
import { createPersistedState } from './pinia-persist';

export function setupPinia(app: App) {
  const pinia = createPinia();

  // Add persistence plugin
  pinia.use(createPersistedState());

  app.use(pinia);

  // Enable HMR in development
  if (import.meta.hot) {
    import.meta.hot.accept();
  }

  return pinia;
}
